import { Route, Routes } from 'react-router-dom';
import SOCHomeScreen from './screens/SOCHomeScreen';

ChargeSOC.propTypes = {};

function ChargeSOC(props) {
  return (
    <div
      className="container-fluid px-0 vh-100"
      style={{
        backgroundColor: '#060615',
      }}
    >
      <Routes>
        <Route path="" element={<SOCHomeScreen />} />
        <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
      </Routes>
    </div>
  );
}

export default ChargeSOC;
